import { FC, useCallback, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { useGetStarterPackagePopupQuery } from 'src/hooks/useContentsMatchQuery';
import { HEADER_BANNERS_QUERY_KEYS } from 'src/hooks/useHeaderBannersQuery';
import useParseStarterPackagePopup from 'src/hooks/useParseStarterPackagePopup';
import { handleContentsMatchStartAtom, handleDisconnectAtom } from 'src/stores/match/atoms';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import StarterPackageNudgingModal from '.';
const MatchStarterPackageNudgingModal: FC = () => {
  const {
    isLoading,
    data,
    isSuccess
  } = useGetStarterPackagePopupQuery();
  const handleContentsMatchStart = useSetAtom(handleContentsMatchStartAtom);
  const closeModal = useSetAtom(closeModalAtom);
  const handleDisconnect = useSetAtom(handleDisconnectAtom);
  const {
    t
  } = useTranslation();
  const queryClient = useQueryClient();
  const onClose = useCallback(() => {
    closeModal(ModalType.STARTER_PACKAGE_NUDGING);
    handleDisconnect({
      reconnect: true,
      finisher: true
    });
  }, [closeModal, handleDisconnect]);
  const starterPackagePopupPage = data?.data.result.popup;
  const {
    singleProductModule,
    starterPackageModule,
    refundPolicyModule
  } = useParseStarterPackagePopup(starterPackagePopupPage);
  useEffect(() => {
    if (!isSuccess) return;
    if (!starterPackagePopupPage) {
      // 스타터패키지 대상이 아닌 경우 (실제 발생 가능하지 않은 엣지 케이스)
      onClose();
      return;
    }
    if (!singleProductModule || !starterPackageModule) {
      // 스타터패키지 팝업 DTO가 유효하지 않은 경우
      onClose();
      return;
    }
    handleContentsMatchStart();
    // 스타터패키지 넛징 배너 노출 유도
    queryClient.invalidateQueries({
      queryKey: HEADER_BANNERS_QUERY_KEYS.getHeaderBanners()
    });
  }, [isSuccess, handleContentsMatchStart, starterPackagePopupPage, onClose, queryClient, singleProductModule, starterPackageModule]);
  const isLoadingStarterPackage = isLoading || !starterPackagePopupPage || !singleProductModule || !starterPackageModule;
  return <StarterPackageNudgingModal onClose={onClose} description={t('popup_web_starterpackage_desc')} {...isLoadingStarterPackage ? {
    isLoading: true
  } : {
    singleProductModule,
    starterPackageModule,
    refundPolicyModule
  }} data-sentry-element="StarterPackageNudgingModal" data-sentry-component="MatchStarterPackageNudgingModal" data-sentry-source-file="MatchStarterPackageNudgingModal.tsx" />;
};
export default MatchStarterPackageNudgingModal;